import { toast } from "react-toastify";

export const downloadFile = async (fileUrl: any, filename: any) => {
  try {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    toast.success("File downloaded successfully!");
  } catch (error) {
    console.error("Download failed:", error);
    toast.error("Failed to download file.");
  }
};

export const downloadLocalFile = (fileObject: any) => {
  const url = URL.createObjectURL(fileObject);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileObject.name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
